<template lang="pug">
.landing-page
  section#parallax.clearfix
    ul#scene.scene
      li.layer(data-depth='0.00', data-invert-y='false')
        .clouds-layer
      li.layer(data-depth='0.20', data-invert-y='false')
        .mountains-layer
      li.layer(data-depth='0.40')
        .kurama
      li.layer(data-depth='0.60')
        .fireflies
      li.layer(data-depth='0.80')
        .logo
          img.logo-main(src='../assets/landing-page/spritely_logo.svg')
    button.btn.btn-green.float-right(@click='goToLoginPage()') Log In
  .top-background
  section.main
    .container
      .row
        .col-12
          button.btn.btn-green.float-right(@click='goToLoginPage()') Log In
      .row
        .col-12
          img.logo-main(src='../assets/landing-page/spritely_logo.svg')
    .decor-border
      img(src='../assets/landing-page/white-border.svg')
  section.white.what
    .container
      .row
        img.egg(src='../assets/landing-page/egg.svg')
        h2.col-12.text-center.green What is Spritely?
        .col-12.col-md-8.offset-md-2
          p
            | Spritely is both a task management integration and an exciting game built on blockchain technology.
            | You'll be collecting, raising, and battling friendly elemental creatures called Sprites as you
            | finish tasks on platforms such as Habitica and Github!
        img.divider(src='../assets/landing-page/divider.svg')
      .row
        .col-12.col-md-4.offset-md-2.d-flex.align-items-center
          div
            h2.blue Collect and Raise Sprites
            p
              | Sprites are cute creatures that grow and evolve into many fantastic and whimsical forms as you
              | level them up by interacting with Spritely and by completing real life tasks.
              | You'll get your first Sprite on us!
        .col-12.col-md-4
          img(src='../assets/landing-page/raise-sprites.svg')
  section.white
    .container
      .row
        .col-12.col-md-4.offset-md-2
          img.nipish(src='../assets/landing-page/battle-monsters@3x.png')
        .col-12.col-md-4.d-flex.align-items-center
          div
            h2.orange Battle Monsters in Events!
            p
              | Your Sprites can also battle enemies. Create an event and your Sprite will bravely attack each time you
              | complete tasks on the apps you've linked to Spritely. With each battle, your Sprite will grow stronger!
  section.white
    .container
      .row
        .col-12.col-md-4.offset-md-2.d-flex.align-items-center
          div
            h2.green Track Your Productivity
            p
              | The success of your Sprites is all because of all the things you accomplish in your integrated apps.
              | Track your productivity each day and take pride in all you get done! Your Sprites will celebrate your
              | achievements by growing and winning battles with enemies.
        .col-12.col-md-4
          img.nipish(src='../assets/landing-page/track-productivity.svg')
  section.white
    .container
      .row
        .col-12.col-md-4.offset-md-2
          img.nipish(src='../assets/landing-page/learn-blockchain.svg')
        .col-12.col-md-4.d-flex.align-items-center
          div
            h2.red Learn About Blockchain Technology
            p Sprites are not only exciting and unusual creatures, they are tokens on the blockchain that are yours and completely unique. Once you’ve adopted a Sprite you can keep it forever, show it off, or even sell it to someone else!
            p New to blockchain technology? Don’t worry, we’ll give you a simple, user-friendly introduction and help you set up your digital wallet. Then you can purchase your first cryptocurrency, collect tradable digital assets (like Sprites!), and interact with others on this decentralized network that puts the power in your hands.
    img.divider2(src='../assets/landing-page/divider.svg')
  section.white.cta
    .container
      .row
        .col-12.text-center
          h2.large-green Ready to find your own sprites?
          h4 We’ll help you find your first!
          button.btn.btn-green(@click='goToLoginPage()') Get Started
    .skyline
      .clouds
      .mountains
</template>

<style lang="scss" scoped>
  @media (max-width: 991.98px) {
    #parallax {
      display: none;
    }

    .top-background, .main .container {
      display: block !important;
    }

    .main {
      height: 75vh !important;
    }

    .logo-main {
      width: 50vw !important;
    }
  }

  /* Responsive ness for skyline */
  @media (max-width: 1070px) {
    .skyline {
      max-height: 370px !important;
    }
  }

  @media (max-width: 530px) {
    .skyline {
      max-height: 340px !important;
    }
  }

  @media (max-width: 400px) {
    .skyline {
      max-height: 300px !important;
    }
  }
  /* Responsive ness for skyline */

  .main {
    height: 0px;

    .btn-green {
      margin-top: 2rem;
    }
  }

  .top-background, .main .container {
    display: none;
  }

  #parallax {
    padding: 0 !important;
    height: 75vh;
    overflow: hidden;
    width: 100%;

    button {
      position: relative;
      z-index: 1;
      top: 2rem;
      right: 4rem;
    }

    ul {
    	margin: 0;
    	padding: 0;
      width: 100%;
    }

    li {
      width: 100%;
    }

    .layer div {
  		position: absolute;
      width: 100%;
    }



    .clouds-layer, .mountains-layer, .fireflies {
      background-position: center;
      background-size: cover;
      width: 100%;
      height: 75vh;
    }

    .fireflies {
      background: url('../assets/banner/fireflies.png');
    }

    .clouds-layer {
      background-image: url('../assets/banner/sky_clouds.png');
    }

    .mountains-layer {
      background-image: url('../assets/banner/mountains.png');
    }

    .mountains-layer {
      left: -2rem;
    }

    .mountains-layer img {
      width: 120%;
    }

    .kurama {
      background: url('../assets/banner/main_scene.png');
      background-position: center;
      background-size: cover;
      margin-left: -10rem;
      width: 120% !important;
      height: 75vh;
    }

    .logo {
      top: 5rem;
    }
  }

  .landing-page {
    text-align: left;
  }

  .top-background {
    z-index: -1;
    position: absolute;
    width: 100%;
    height: 75vh;
    background-position: center;
    background-size: cover;
    background-image: url('../assets/landing-page/website_banner_fullres.png');
      // image-set(
      //   url('../assets/landing-page/banner.png') 1x,
      //   url('../assets/landing-page/banner@2x.png') 2x,
      //   url('../assets/landing-page/banner@3x.png') 3x,
      // );
  }

  .logo-main {
    width: 20vw;
    margin: 0 auto;
  }

  .decor-border {
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 0;
    margin-bottom: -.2em;

    img {
      width: 100%;
    }
  }

  h2 {
    font-size: 24px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
  }

  h4 {
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    color: #6c6d69;
  }

  .green {
    color: #9bc75a;
  }

  .blue {
    color: #3ba5a8;
  }

  .orange {
    color: #eea830;
  }

  .green {
    color: #9bc75a;
  }

  .red {
    color: #e14455;
  }

  .large-green {
    font-size: 32px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.25;
    letter-spacing: normal;
    text-align: center;
    color: #9bc75a;
  }

  .nipish {
    width: 301px;
  }

  p {
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #6c6d69;
  }

  section {
    padding-top: 1rem;
    padding-bottom: 1rem;
    width: 100%;
  }

  section.white {
    background-color: #fff;
  }

  section.what, .container.main {
    padding-top: 2rem;
  }

  .what {
    .egg {
      margin: 1rem auto;
      margin-bottom: 2rem;
    }

    .divider {
      margin-top: 2rem;
      margin-bottom: 2rem;
    }
  }

  .divider2 {
    margin-top: 8rem;
    margin-bottom: 8rem;
  }

  img {
    display: block;
    margin: 0 auto;
  }

  .row {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .main {
    // min-height: 100vh;
    padding-bottom: 0;
    padding-top: 0;
    position: relative;

    h2 {
      text-align: center;
    }

    .row {
      margin-top: 0;
    }
  }

  .btn-green, .btn-green:focus, .btn-green:active, .btn-green:visited {
    border-radius: 999px;
    background-image: linear-gradient(to right, #9bc75a, #3ba5a8);
    color: #fff;
    text-transform: uppercase;
    padding: .5rem 2rem;
    border: none;
  }

  .cta {
    padding-bottom: 8rem;
    position: relative;

    h4 {
      margin-bottom: 2rem;
    }

    .container {
      position: relative;
      z-index: 1;
    }
  }

  .skyline {
    position: absolute;
    bottom: 0;
    width: 100%;
    max-height: 500px;
  }

  .clouds {
    background-image: url('../assets/landing-page/landing_clouds.svg');
    background-repeat: no-repeat;
    margin: 0 auto;
    height: 244px;
    width: 1150px;
  }

  .mountains {
    background-image: url('../assets/landing-page/landing_mountains.svg');
    background-repeat: repeat-x;
    height: 342px;
  }
</style>

<script>
export default {
  mounted() {
    window.$('#scene').parallax();
  },
  methods: {
    goToLoginPage() {
      this.$router.push({ name: 'HabiticaLogin' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/LandingPage.vue